module.exports = __webpack_public_path__ + "static/wl-coral-theme-11be22d23d62bf603b967503d720e802.png";